import { render, staticRenderFns } from "./carer-detail.vue?vue&type=template&id=0e00215a&"
import script from "./carer-detail.component.ts?vue&type=script&lang=ts&"
export * from "./carer-detail.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports